// Единый каталог услуг. Используется в лентах услуг на главной (короткий desc)
// и на странице «Услуги» (аккордеон: image + full + bullets).
// image — путь из /public/services.

// Нейтральный вариант для селектов в формах — если клиент не выбрал конкретную услугу.
export const NEUTRAL_SERVICE = "Нужна консультация";

export const services = [
  {
    num: "01",
    name: "Вентиляция",
    icon: "Fan",
    desc:
      "Приточно-вытяжные системы с рекуперацией для квартир, домов и коммерческих зданий.",
    image: "/services/ventilyaciya.jpg",
    full:
      "Проектируем и монтируем приточно-вытяжную вентиляцию с рекуперацией тепла — система подаёт свежий воздух и удаляет отработанный, сохраняя до 90% тепла зимой и прохлады летом. Подбираем оборудование под площадь и назначение помещений, рассчитываем воздухообмен по нормам и сводим уровень шума к минимуму.",
    bullets: [
      "Расчёт воздухообмена и подбор установок по СНиП и СП",
      "Приточно-вытяжные системы с рекуперацией тепла",
      "Монтаж воздуховодов, шумоглушителей и диффузоров",
      "Пусконаладка и настройка автоматики",
    ],
  },
  {
    num: "02",
    name: "Кондиционирование",
    icon: "AirVent",
    desc:
      "Подбор, монтаж и сервис сплит-систем и мультизональных решений любой сложности.",
    image: "/services/konditsionirovanie.jpeg",
    full:
      "Подбираем, поставляем и устанавливаем сплит-системы, мультисплиты и канальные кондиционеры для любого помещения. Учитываем теплопритоки, площадь остекления и назначение комнат, чтобы климат был комфортным, а счета за электричество — предсказуемыми. Выполняем монтаж аккуратно, с опрессовкой и вакуумированием трассы.",
    bullets: [
      "Подбор мощности по теплопритокам помещения",
      "Монтаж сплит- и мультисплит-систем, канальных блоков",
      "Прокладка и опрессовка фреоновой трассы",
      "Сервисное обслуживание и заправка хладагентом",
    ],
  },
  {
    num: "03",
    name: "VRV-системы",
    icon: "Boxes",
    desc:
      "Мультизональные системы для зданий любой площади с точным климат-контролем по зонам.",
    image: "/services/vrv.jpeg",
    full:
      "VRV — мультизональные системы, где один наружный блок обслуживает десятки внутренних с индивидуальной настройкой климата в каждой зоне. Идеальное решение для коттеджей, офисов и зданий со сложной планировкой: экономия места на фасаде, точное регулирование температуры и высокая энергоэффективность.",
    bullets: [
      "Проект мультизональной системы под планировку объекта",
      "Индивидуальный климат-контроль в каждом помещении",
      "Один наружный блок на десятки внутренних",
      "Интеграция с системами диспетчеризации здания",
    ],
  },
  {
    num: "04",
    name: "VRF-системы",
    icon: "Server",
    desc:
      "Энергоэффективный климат для офисов, отелей и торговых центров с гибким управлением.",
    image: "/services/vrf.jpeg",
    full:
      "VRF-системы с переменным расходом хладагента созданы для крупных коммерческих объектов: торговых центров, отелей, бизнес-центров. Они одновременно охлаждают одни помещения и обогревают другие, перераспределяя энергию внутри контура, что заметно снижает эксплуатационные расходы.",
    bullets: [
      "Расчёт и проект для зданий большой площади",
      "Одновременный нагрев и охлаждение разных зон",
      "Сниженные эксплуатационные расходы",
      "Централизованное управление и мониторинг",
    ],
  },
  {
    num: "05",
    name: "Отопление",
    icon: "Flame",
    desc:
      "Радиаторы, тёплые полы и котельные — проект и монтаж систем отопления под ключ.",
    image: "/services/otoplenie.jpeg",
    full:
      "Проектируем и монтируем системы отопления под ключ: радиаторное, тёплые полы, котельные и тепловые насосы. Делаем гидравлический расчёт, подбираем котёл и схему разводки так, чтобы дом прогревался равномерно, а расход топлива был минимальным.",
    bullets: [
      "Гидравлический и тепловой расчёт системы",
      "Радиаторное отопление и тёплые полы",
      "Монтаж котельных и тепловых пунктов",
      "Балансировка и запуск системы",
    ],
  },
  {
    num: "06",
    name: "Электромонтаж",
    icon: "Zap",
    desc:
      "Электромонтажные работы под ключ: электроснабжение климатического оборудования.",
    image: "/services/elektromontazh.jpg",
    full:
      "Выполняем электромонтажные работы под ключ для питания климатического оборудования. Проектируем щиты, прокладываем кабельные трассы, устанавливаем автоматику и защиту — всё по ПУЭ, с протоколами и гарантией на работы.",
    bullets: [
      "Проект электроснабжения и сборка щитов",
      "Прокладка силовых кабельных трасс",
      "Подключение и защита климатического оборудования",
      "Электроизмерения и протоколы по ПУЭ",
    ],
  },
  {
    num: "07",
    name: "Проектирование",
    icon: "PencilRuler",
    desc:
      "Полный комплект проектной документации: расчёт, чертежи и согласование.",
    image: "/services/proektirovanie.jpg",
    full:
      "Разрабатываем полный комплект проектной документации по разделам ОВ, ВК и ЭОМ: инженерные расчёты, рабочие чертежи, спецификации оборудования и материалов. Грамотный проект — это предсказуемый бюджет, отсутствие переделок на монтаже и простое согласование с надзорными органами.",
    bullets: [
      "Разделы ОВ, ВК, ЭОМ и пояснительные записки",
      "Инженерные расчёты и подбор оборудования",
      "Рабочие чертежи и спецификации",
      "Сопровождение согласований",
    ],
  },
];
